<template>
  <div class="page" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="card">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClickTab">
        <el-tab-pane :label="$t('product.byDesignerID&ColorCode')" name="first"></el-tab-pane>
        <el-tab-pane :label="$t('product.brand&CategorySearch')" name="second"></el-tab-pane>
      </el-tabs>

      <el-form :model="queryForm" label-width="100px">
        <el-row>
          <el-col :md="24" :lg="12" :xl="6">
            <el-form-item
              v-if="activeName === 'first'"
              :label="$t('common.brand')"
              :rules="[{ required: true, message: $t('product.pleaseSelectBrand') }]"
            >
              <brand-select
                :data="brandList"
                v-model="queryForm.brandId"
                :placeholder="$t('product.pleaseInputOriginalBrand')"
                clearable
              ></brand-select>
            </el-form-item>
            <el-form-item
              v-if="activeName === 'first'"
              :label="$t('common.designerId')"
              :rules="[{ required: true, message: $t('product.pleaseInputDesignerId') }]"
            >
              <el-input v-model="queryForm.designerId" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item v-if="activeName === 'first'" :label="$t('common.color')">
              <el-input v-model="queryForm.colorCode" maxlength="50"></el-input>
            </el-form-item>

            <el-form-item v-if="activeName === 'second'" :label="$t('common.brand')">
              <brand-select
                :data="brandList"
                v-model="queryForm.brandIds"
                :placeholder="$t('product.pleaseInputOriginalBrand')"
                multiple
                clearable
              ></brand-select>
            </el-form-item>
            <el-form-item v-if="activeName === 'second'" :label="$t('common.category')">
              <el-cascader
                v-model="selectedCategory"
                clearable
                :props="{ value: 'categoryId', label: 'name', multiple: true }"
                :options="categoryList"
                @change="selectCategory"
                style="width: 100%"
              ></el-cascader>
            </el-form-item>
            <el-form-item v-if="activeName === 'second'" :label="$t('common.season')">
              <el-select v-model="queryForm.seasonCode" style="width: 100%">
                <el-option v-for="item in seasonList" :label="item.seasonCode" :value="item.seasonCode" :key="item.seasonCode"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="searchQuery">{{ $t('common.search') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="card pb20">
      <h2 class="mb10">{{ $t('product.searchResult') }}</h2>

      <template v-if="loaded === 1">
        <p>{{ $t('product.createBySearchT1') }}</p>
        <p>{{ $t('product.createBySearchT2') }}</p>
        <p>{{ $t('product.createBySearchT3') }}</p>
        <p>{{ $t('product.createBySearchT4') }}</p>
      </template>

      <p v-if="loaded === 2 && total === 0">
        {{ $t('product.sorryNotFind') }}<router-link :to="{ path: '/product/create' }">{{ $t('product.createByFilling') }}</router-link>
      </p>

      <div class="single" v-if="total === 1 && loaded > 1">
        <el-image
          class="img"
          :src="tableData[0].img + '?x-oss-process=image/auto-orient,1/resize,m_lfit,w_500/quality,q_100/format,jpg'"
          :preview-src-list="tableData[0].coverImg"
        ></el-image>
        <div>
          <p><span class="bold">Brand：</span>{{ tableData[0].brandName }}</p>
          <p class="mt10 keep-space">
            <span class="label">{{ $t('common.designerId') }}：</span>{{ tableData[0].designerId }}
          </p>
          <p class="mt10 keep-space">
            <span class="label">{{ $t('common.color') }}：</span>{{ tableData[0].colorCode }}
          </p>
          <p class="mt10">
            <span class="label">{{ $t('common.category') }}：</span>{{ tableData[0].categoryAllName }}
          </p>
          <p class="mt10">
            <span class="label">{{ $t('common.season') }}：</span>{{ tableData[0].seasonCode }}
          </p>
          <p class="mt10">
            <el-button type="primary" @click="copyToCreate(tableData[0])">{{ $t('common.create') }}</el-button>
          </p>
        </div>
      </div>

      <div class="list" v-if="total > 1 && loaded > 1">
        <div class="item" v-for="item in tableData" :key="item.id">
          <el-image
            class="img"
            :src="item.img + '?x-oss-process=image/auto-orient,1/resize,m_lfit,w_240/quality,q_100/format,jpg'"
            :preview-src-list="item.coverImg"
          ></el-image>
          <div>
            <p>{{ item.brandName }}</p>
            <p class="mt5">{{ item.categoryAllName }}</p>
            <p class="mt5 keep-space">
              <span class="label">{{ $t('common.designerId') }}：</span>{{ item.designerId }}
            </p>
            <p class="mt5 keep-space">
              <span class="label">{{ $t('common.color') }}：</span>{{ item.colorCode }}
            </p>
            <p class="mt5">
              <span class="label">{{ $t('common.season') }}：</span>{{ item.seasonCode }}
            </p>
            <p class="mt5">
              <el-button size="mini" type="primary" @click="copyToCreate(item)">{{ $t('common.create') }}</el-button>
            </p>
          </div>
        </div>
      </div>
      <el-pagination
        v-if="total > 1 && loaded > 1"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>

      <el-dialog :title="$t('product.sizeStock')" :visible.sync="dialogVisible" :close-on-click-modal="false" width="850px">
        <el-select v-model="wholesaleNo" style="width: 100%;margin-bottom:10px" :placeholder="$t('product.wholesaleNo')" v-if="vendorType == 7">
          <el-option v-for="item in codeList" :key="item.wholesaleNo" :label="item.wholesaleNo" :value="item.wholesaleNo"></el-option>
        </el-select>
        <el-select v-model="selectedStandard" style="width: 100%" :placeholder="$t('product.selectSizeStandard')" @change="changeSize">
          <el-option v-for="item in standardList" :key="item.packageSizeId" :label="item.sizeStandard" :value="item.packageSizeId"></el-option>
        </el-select>
        <p v-if="selectedSize && selectedSize.sizeStandard === 'Others'" class="mt10 mb10">
          <span class="bold">{{ $t('product.sizeStandard') }}</span>
          <el-input style="width: 200px" size="small" v-model="inputStandard"></el-input>
          <span class="f12">*{{ $t('product.pleaseHelpUsFill') }}</span>
        </p>
        <el-table v-if="selectedStandard" :data="sizeList" style="width: 100%">
          <el-table-column class-name="el-table-pd5" width="55">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked"></el-checkbox>
              <!-- 此处勾选只用作批量输入，和提交没有关系 -->
            </template>
          </el-table-column>
          <el-table-column class-name="el-table-pd5" :label="$t('common.size')">
            <template slot-scope="scope">
              <el-input size="mini" v-model.trim="scope.row.size"></el-input>
            </template>
          </el-table-column>
          <el-table-column class-name="el-table-pd5">
            <template slot="header" slot-scope="{}">
              {{ $t('product.skuCode') }}
              <el-input
                size="mini"
                v-model.trim="thead.skuCode"
                @keypress.enter.native="batchChange('skuCode')"
                :placeholder="$t('product.inputPressEnter')"
              ></el-input>
            </template>
            <template slot-scope="scope">
              <el-input size="mini" v-model.trim="scope.row.skuCode"></el-input>
            </template>
          </el-table-column>
          <el-table-column class-name="el-table-pd5">
            <template slot="header" slot-scope="{}">
              <template v-if="isPriceWhiteList">
                {{ $t('common.retailPrice') }}<br />
                <span class="f12">({{ originalPriceUnit }}/{{ retailPriceIncludingTax === 1 ? $t('common.incldVAT') : $t('common.excldVAT') }})</span>
              </template>
              <template v-else>
                {{ $t('common.retailPrice') }}
              </template>
              <el-input
                size="mini"
                v-model.trim="thead.retailPrice"
                :disabled="provideRetailPrice === 2"
                @keypress.enter.native="batchChange('retailPrice')"
                :placeholder="$t('product.inputPressEnter')"
              ></el-input>
            </template>
            <template slot-scope="scope">
              <el-input size="mini" v-model.trim="scope.row.retailPrice" :disabled="provideRetailPrice === 2"></el-input>
            </template>
          </el-table-column>
          <el-table-column class-name="el-table-pd5" v-if="supplyPriceMethod === 1">
            <template slot="header" slot-scope="{}">
              <template v-if="isPriceWhiteList">
                {{ $t('common.supplyPrice') }}<br />
                <span class="f12">({{ originalPriceUnit }}/{{ includingTax === 1 ? $t('common.incldVAT') : $t('common.excldVAT') }})</span>
              </template>
              <template v-else>
                {{ $t('common.supplyPrice') }}
              </template>
              <el-input
                size="mini"
                v-model.trim="thead.supplyPrice"
                @keypress.enter.native="batchChange('supplyPrice')"
                :placeholder="$t('product.inputPressEnter')"
              ></el-input>
            </template>
            <template slot-scope="scope">
              <el-input size="mini" v-model.trim="scope.row.supplyPrice"></el-input>
            </template>
          </el-table-column>
          <el-table-column class-name="el-table-pd5" v-if="supplyPriceMethod === 2">
            <template slot="header" slot-scope="{}">
              {{ $t('product.costPrice') }}
              <el-input
                size="mini"
                v-model.trim="thead.costPrice"
                @keypress.enter.native="batchChange('costPrice')"
                :placeholder="$t('product.inputPressEnter')"
              ></el-input>
            </template>
            <template slot-scope="scope">
              <el-input size="mini" v-model.trim="scope.row.costPrice" @change="changeCostPrice(scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column class-name="el-table-pd5">
            <template slot="header" slot-scope="{}">
              {{ $t('common.stock') }}
              <el-input
                size="mini"
                v-model.trim="thead.stock"
                @keypress.enter.native="batchChange('stock')"
                :placeholder="$t('product.inputPressEnter')"
              ></el-input>
            </template>
            <template slot-scope="scope">
              <el-input size="mini" v-model.trim="scope.row.stock"></el-input>
            </template>
          </el-table-column>
          <el-table-column class-name="el-table-pd5">
            <template slot="header" slot-scope="{}">
              {{ $t('common.action') }}<br />
              <el-button size="mini" type="primary" :disabled="disabledBatchEnter" @click="batchEnter">{{ $t('product.batchEnter') }}</el-button>
            </template>
            <template slot-scope="scope">
              <el-link type="primary" @click="removeItem(scope)">{{ $t('common.delete') }}</el-link>
            </template>
          </el-table-column>
          <div slot="append" style="padding: 0 10px">
            <el-button type="text" @click="addSize">+ {{ $t('product.addNewSize') }}</el-button>
          </div>
        </el-table>
        <p v-if="selectedStandard" class="mt10">*{{ $t('product.afterFillingFirstLine') }}</p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="createProduct">{{ $t('common.create') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BrandSelect from '../../components/BrandSelect';
import {
  getBrandList,
  seasonList,
  getCategoryList,
  searchProductListByDesignerId,
  searchProductListByCategoryId,
  getSizeStandardList,
  getSizeListByPackageSizeId,
  copyCreateProduct,
  getWholesaleValidList
} from '../../api/product';
import { getUserInfo } from "../../api/system"

const priceRegex = /^\d+(\.\d{1,2})?$/;
const stockRegex = /[\.]/;

export default {
  name: 'CreateBySearch',
  components: {
    BrandSelect,
  },
  data() {
    return {
      fullscreenLoading: false,
      activeName: 'first',
      seasonList: [],
      brandList: [],
      categoryList: [],
      selectedCategory: [],
      queryForm: {
        brandId: null,
        brandIds: [],
        designerId: '',
        colorCode: null,
        categoryIds: [],
        seasonIds: [],
        pageNo: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0,
      loaded: 1,
      dialogVisible: false,
      standardList: [],
      sizeList: [],
      thead: {
        skuCode: null,
        retailPrice: null,
        supplyPrice: null,
        costPrice: null,
        stock: null,
      },
      selectedStandard: null,
      selectedSize: null,
      inputStandard: null,
      codeList: [],
      wholesaleNo: null
    };
  },
  computed: {
    ...mapState({
      supplyPriceMethod: (state) => state.userinfo.supplyPriceMethod,
      provideRetailPrice: (state) => state.userinfo.provideRetailPrice,
      costRetailPriceCoefficient: (state) => state.userinfo.costRetailPriceCoefficient,
      originalPriceUnit: (state) => state.userinfo.originalPriceUnit,
      stockExpiryFlag: (state) => state.userinfo.stockExpiryFlag,
      isPriceWhiteList: (state) => state.userinfo.isPriceWhiteList,
      retailPriceIncludingTax: (state) => state.userinfo.retailPriceIncludingTax,
      includingTax: (state) => state.userinfo.includingTax,
      vendorType: (state) => state.userinfo.vendorType,
    }),
    disabledBatchEnter() {
      return !this.sizeList.some((item) => item.checked);
    },
  },
  created() {
    getBrandList().then((res) => {
      this.brandList = res.data;
    });
    seasonList().then((res) => {
      this.seasonList = res.data;
    });
    getCategoryList().then((res) => {
      this.categoryList = res.data.map((item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach((item2) => {
            if (item2.children && item2.children.length > 0) {
              item2.children.forEach((item3) => {
                item3.children = item3.children.length === 0 ? null : item3.children;
              });
            } else {
              item2.children = null;
            }
          });
        } else {
          item.children = null;
        }
        return item;
      });
    });
    getUserInfo().then((res) => {
      if (res && res.data) {
        if(res.data.vendorType === 7){
          this.getWholesaleValidList()
        }
      }
    });
  },
  methods: {
    handleClickTab() {
      this.queryForm.brandId = null;
      this.queryForm.brandIds = [];
      this.queryForm.designerId = null;
      this.queryForm.colorCode = null;
      this.queryForm.categoryIds = [];
      this.queryForm.seasonIds = [];
      this.queryForm.pageNo = 1;
      this.selectedCategory = [];
      this.total = 0;
      this.tableData = [];
    },
    searchQuery() {
      if (this.activeName === 'first') {
        if (!this.queryForm.brandId) {
          this.$message(this.$t('product.pleaseSelectBrand'));
          return;
        }
        if (!this.queryForm.designerId) {
          this.$message(this.$t('product.pleaseInputDesignerId'));
          return;
        }
      } else if (this.queryForm.brandIds.length === 0 && this.queryForm.categoryIds.length === 0 && this.queryForm.seasonIds.length === 0) {
        this.$message(this.$t('product.pleaseEnterLeastOne'));
        return;
      }
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    selectCategory(res) {
      this.queryForm.categoryIds = res.map((item) => item[2]);
    },
    getTableData() {
      this.fullscreenLoading = true;
      const params = {
        current: this.queryForm.pageNo,
        size: this.queryForm.pageSize,
        designerId: this.queryForm.designerId || null,
        colorCode: this.queryForm.colorCode || null,
        categoryIds: this.queryForm.categoryIds,
        seasonIds: this.queryForm.seasonIds,
      };
      let request = searchProductListByDesignerId;
      if (this.activeName === 'second') {
        request = searchProductListByCategoryId;
        params.brandIds = this.queryForm.brandIds;
        if (this.queryForm.brandIds.length === 0 && this.queryForm.categoryIds.length === 0 && this.queryForm.seasonIds.length === 0) {
          return;
        }
      } else {
        params.brandIds = this.queryForm.brandId ? [this.queryForm.brandId] : [];
      }
      request(params).then((res) => {
        this.fullscreenLoading = false;
        if (res.success) {
          this.total = res.data.total;
          this.tableData = (res.data.list || []).map((item) => {
            const coverImg = JSON.parse(item.coverImg);
            return {
              img: coverImg ? coverImg[0] : null,
              ...item,
              coverImg,
            };
          });
          if (this.total === 0) {
            this.loaded = 2;
          } else {
            this.loaded = 3;
          }
        } else {
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    copyToCreate(item) {
      this.product = item;
      this.sizeList = [];
      this.thead.skuCode = null;
      this.thead.retailPrice = null;
      this.thead.supplyPrice = null;
      this.thead.costPrice = null;
      this.thead.stock = null;
      this.selectedStandard = null;
      this.selectedSize = null;
      this.inputStandard = null;
      this.wholesaleNo = null;
      getSizeStandardList({
        brandId: item.brandId,
        categoryId: item.categoryId,
      }).then((res) => {
        this.standardList = res.data;
      });
      this.saleSpuId = item.saleSpuId;
      this.dialogVisible = true;
    },
    changeSize(val) {
      this.inputStandard = null;
      let size = null;
      this.standardList.some((item) => {
        if (item.packageSizeId === val) {
          size = item;
          return true;
        }
        return false;
      });
      this.selectedSize = size;
      this.sizeList = [];
      this.packageSizeId = size.packageSizeId;
      this.sizeStandardId = size.sizeStandardId;
      getSizeListByPackageSizeId({
        packageSizeId: size.packageSizeId,
      }).then((res) => {
        if (res.data.length === 0) {
          res.data.push({});
        }
        this.sizeList = res.data.map((item) => ({
          ...item,
          skuCode: null,
          retailPrice: null,
          supplyPrice: null,
          costPrice: null,
          stock: null,
          checked: false,
        }));
      });
    },
    addSize() {
      this.sizeList.push({
        size: null,
        skuCode: null,
        retailPrice: null,
        supplyPrice: null,
        costPrice: null,
        stock: null,
      });
    },
    batchChange(key) {
      this.sizeList.forEach((item) => {
        if (item.checked) {
          item[key] = this.thead[key];
        }
      });
    },
    batchEnter() {
      if (this.thead.skuCode) {
        this.batchChange('skuCode');
      }
      if (this.supplyPriceMethod === 2 && this.thead.costPrice) {
        if (this.provideRetailPrice === 2) {
          this.thead.retailPrice = (this.thead.costPrice * this.costRetailPriceCoefficient).toFixed(2);
        }
        this.batchChange('costPrice');
      }
      if (this.thead.retailPrice) {
        this.batchChange('retailPrice');
      }
      if (this.supplyPriceMethod === 1 && this.thead.supplyPrice) {
        this.batchChange('supplyPrice');
      }
      if (this.thead.stock) {
        this.batchChange('stock');
      }
    },
    removeItem(scope) {
      this.sizeList.splice(scope.$index, 1);
    },
    createProduct() {
      const sizeArr = [];
      const temp = [];

      if (this.vendorType == 7 && !this.wholesaleNo){
        this.$message.error(this.$t('product.wholesaleNo'));
        return;
      }

      const hasData = this.sizeList.some((item) => {
        if (
          item.supplyPrice === null ||
          item.supplyPrice === '' ||
          item.costPrice === null ||
          item.costPrice === '' ||
          item.retailPrice === null ||
          item.retailPrice === '' ||
          item.stock === null ||
          item.stock === ''
        ) {
          return true;
        }
        return false;
      });
      if (!hasData) {
        if (this.supplyPriceMethod === 1) {
          this.$message.error(this.$t('product.pleaseEnterSupplyPrice'));
          return;
        }
        if (this.supplyPriceMethod === 2) {
          this.$message.error(this.$t('product.pleaseEnterCostPrice'));
          return;
        }
        this.$message.error(this.$t('product.pleaseInputRetailPrice'));
        return;
      }

      this.sizeList.forEach((item) => {
        if (
          (this.supplyPriceMethod === 1 ? item.supplyPrice !== '' && item.supplyPrice !== null : false) ||
          (this.supplyPriceMethod === 2 ? item.costPrice !== '' && item.costPrice != null : false) ||
          (item.retailPrice !== '' && item.retailPrice != null) ||
          (item.stock !== '' && item.stock != null)
        ) {
          item.sizeStandard = this.inputStandard;
          temp.push(item);
        }
        return false;
      });

      for (let i = 0; i < temp.length; i++) {
        if (!temp[i].size) {
          this.$message({
            message: this.$t('product.pleaseInputSize'),
            type: 'error',
          });
          return;
        }
        sizeArr.push(temp[i].size);
        if (this.supplyPriceMethod === 1) {
          if (temp[i].supplyPrice === null || temp[i].supplyPrice === '') {
            this.$message.error(this.$t('product.pleaseEnterSupplyPrice'));
            return;
          }
          if (temp[i].supplyPrice <= 0 || !priceRegex.test(temp[i].supplyPrice)) {
            this.$message.error(this.$t('product.priceMustGreaterThan'));
            return;
          }
        }
        if (this.supplyPriceMethod === 2) {
          if (temp[i].costPrice === null || temp[i].costPrice === '') {
            this.$message.error(this.$t('product.pleaseEnterCostPrice'));
            return;
          }
          if (temp[i].costPrice <= 0 || !priceRegex.test(temp[i].costPrice)) {
            this.$message.error(this.$t('product.priceMustGreaterThan'));
            return;
          }
        }
        if (temp[i].retailPrice === null || temp[i].retailPrice === '') {
          this.$message.error(this.$t('product.pleaseInputRetailPrice'));
          return;
        }
        if (temp[i].retailPrice <= 0 || !priceRegex.test(temp[i].retailPrice)) {
          this.$message.error(this.$t('product.priceMustGreaterThan'));
          return;
        }
        if (temp[i].stock === null || temp[i].stock === '') {
          this.$message.error(this.$t('product.pleaseEnterStockQuantity'));
          return;
        }
        if (temp[i].stock <= 0 || stockRegex.test(temp[i].stock)) {
          this.$message.error(this.$t('product.inventoryMustIntegerGreaterThan'));
          return;
        }
      }
      copyCreateProduct({
        saleSpuId: this.saleSpuId,
        sizeStandardId: this.sizeStandardId,
        packageSizeId: this.packageSizeId,
        productSkuVOS: temp,
        wholesaleNo: this.wholesaleNo
      }).then((res) => {
        if (res.success) {
          this.$message.success(this.$t('error.successful'));
          this.dialogVisible = false;
        } else {
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
      });
    },
    changeCostPrice(row) {
      if (this.provideRetailPrice === 2) {
        if (row.costPrice === null || row.costPrice === '') {
          row.retailPrice = '';
        } else {
          row.retailPrice = (row.costPrice * this.costRetailPriceCoefficient).toFixed(2);
        }
      }
    },
    getWholesaleValidList() {
      getWholesaleValidList().then((res) => {
        this.codeList = res.data || [];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 12px;
  font-weight: 300;
}
.single {
  display: flex;
  align-items: center;

  .img {
    width: 250px;
    margin-right: 20px;
  }
}
.list {
  display: flex;
  flex-flow: wrap;

  .item {
    display: flex;
    align-items: center;
    width: 350px;
    padding: 10px;
    margin-bottom: 10px;
    margin-right: 10px;
    font-size: 12px;
    border: 2px solid #e4e7ed;
    border-radius: 4px;

    .img {
      width: 120px;
      margin-right: 10px;
    }
  }
}
</style>
